module.exports = __webpack_public_path__ + "static/img/img11-1.e51de3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img11-1.png
// module id = NKcy
// module chunks = 0